// MSAL Configuration for Technofocus Azure AD
import { LogLevel } from '@azure/msal-browser';

// Technofocus Azure AD Configuration — sourced from env vars so frontend and
// backend (AZURE_CLIENT_ID/AZURE_TENANT_ID) always use the SAME tenant/app
// registration. If the env var is missing OR not a valid Azure AD GUID (e.g. it
// got overwritten with the app/preview slug on fork/redeploy/publish), we fall
// back to the real Technofocus GUIDs so SSO logins keep working regardless.
const GUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const REAL_CLIENT_ID = "53057731-4231-4aef-84c4-5bf098075490";
const REAL_TENANT_ID = "205736a0-61cf-43e9-ba14-0ef95bc5a594";
const guidOrFallback = (val, fallback) => (val && GUID_RE.test(val) ? val : fallback);
const clientId = guidOrFallback(process.env.REACT_APP_AZURE_CLIENT_ID, REAL_CLIENT_ID);
const tenantId = guidOrFallback(process.env.REACT_APP_AZURE_TENANT_ID, REAL_TENANT_ID);

export const msalConfig = {
  auth: {
    clientId: clientId,
    // Standard Azure AD authority with tenant ID
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin + "/auth/callback",
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Info:
            console.info(message);
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          default:
            break;
        }
      },
      piiLoggingEnabled: false,
      logLevel: LogLevel.Warning,
    },
    allowRedirectInIframe: false,
  }
};

// Scopes for login
export const loginRequest = {
  scopes: ["openid", "profile", "email", "User.Read"],
};

// Scopes for Microsoft Graph API
export const graphApiRequest = {
  scopes: ["https://graph.microsoft.com/User.Read"],
};

// Scopes for Content Development -> Microsoft Planner task assignment (incremental consent)
export const plannerScopesRequest = {
  scopes: ["Tasks.ReadWrite", "Group.Read.All", "User.Read.All"],
};

// Technofocus domains - primary users of the system
export const TECHNOFOCUS_DOMAINS = ["technofocus.in", "technofocus.co"];

// Check if email is from Technofocus domain
export const isTechnofocusEmail = (email) => {
  if (!email) return false;
  const domain = email.split("@")[1]?.toLowerCase();
  return domain && TECHNOFOCUS_DOMAINS.includes(domain);
};
